<template>
  <div class="candidate-line" :class="candidateLineClasses">
    <div class="candidate-wrapper">
      <draggable v-model="chartValues.values"
        :options="{ dragClass: 'is-dragged' }"
        @start="currentlyDragging = true"
        :move="onMove"
        @end="onEnd"
      >
        <div class="candidate-container"
          v-for="answer in chartValues.values"
          v-bind:key="answer.answerId"
          v-if="answer.answered">
          <div class="candidate-border" v-bind:class="opts.options.shape">
            <div class="candidate-label">
              <span v-html="answer.label"></span>
            </div>
            <img :src="`${answer.picture}`" :alt="`${answer.pictureAlt || ''}`" class="candidate-picture" />
          </div>
          <div class="candidate-percentage" v-bind:class="opts.options.shape" v-if="opts.options.showPercents">
            <p>{{answer.percent}}<span>%</span></p>
          </div>
          <span class="mobile-candidate-label" v-html="answer.label"></span>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { calculatePercentage } from '../../helpers/calculatePercentage'

export default {
  name: 'TeamSelector',
  props: ['chartData', 'translations', 'opts'],
  data () {
    return {
      chartValues: {
        totalPercent: 0,
        values: [],
        percents: []
      },
      chartTotal: this.total,
      lastOnMoveEvent: false,
      currentlyDragging: false
    }
  },
  computed: {
    candidateLineClasses () {
      return {
        [this.opts.options.sport]: true,
        'is-dropzone': this.currentlyDragging
      }
    }
  },
  methods: {
    resizeAndSetDivHeight: function () {
      const divs = document.getElementsByClassName('candidate-container')
      if (!divs[0]) return
      var w = divs[0].offsetWidth

      for (var i = 0; i < divs.length; i++) {
        if (w !== 0) {
          divs[i].style.height = w + 'px'
        }
      }
    },
    onMove (event) {
      this.lastOnMoveEvent = event
      return false
    },
    onEnd (event) {
      this.currentlyDragging = false
      if (this.lastOnMoveEvent) {
        const indexFrom = this.lastOnMoveEvent.draggedContext.index
        const indexTo = this.lastOnMoveEvent.draggedContext.futureIndex
        const tmp = this.chartValues.values[indexTo]
        this.chartValues.values[indexTo] = this.chartValues.values[indexFrom]
        this.chartValues.values[indexFrom] = tmp
      }
    }
  },
  mounted () {
    let falsedPercents = []
    for (let i = 0; i < this.chartData.answersData.length; i++) {
      if (this.chartData.totalVotes !== 0) {
        if (this.chartData.answersData[i].result !== 0) {
          falsedPercents.push(Math.round(calculatePercentage(this.chartData.answersData[i].result, this.chartData.total, 1)))
        } else {
          falsedPercents.push(0)
        }
      }
    }

    this.chartValues.percents = falsedPercents

    this.chartValues.totalPercent = this.chartValues.percents.reduce((acc, x) => { acc += x; return acc }, 0)

    this.chartValues.values = this.chartData.answersData.map((v, i) => {
      return Object.assign(v, { percent: this.chartValues.percents[i] })
    }).filter(v => v.answered)

    setTimeout(() => {
      var that = this
      that.resizeAndSetDivHeight()
      window.addEventListener('resize', function (e) { that.resizeAndSetDivHeight() })
    })
  },
  components: {
    draggable
  }
}
</script>

<style scoped src="../../assets/css/team-selector.css">
</style>



// WEBPACK FOOTER //
// src/components/charts/TeamSelector.vue